module.exports = __webpack_public_path__ + "static/lakeside-ae35dd49164e0761a8d3083f5ac6e0d1.png";